import * as React from "react";

import ClubInClubWidget, { clubInClubWidgetRenders } from "./ClubInClubWidget";
import HomeCallout from "./HomeCallout";
import { useHomeClubInClub } from "./HomeClubInClubContext";

/**
 * The first thing on the home screen.
 *
 * Ask Volley, except for members the Club-in-Club widget has something to say to, who get
 * that instead. The trial is measuring whether members act on their club standing when it
 * leads the screen, and two callouts competing for that position would blunt both — so
 * this is a swap rather than an addition.
 *
 * Keyed on whether the widget will actually render, NOT on the feature flag. The flag is
 * granted to a cohort; the widget only appears for those in it who have a Club-in-Club
 * record or can create one. Swapping on the flag meant everyone else — including every
 * admin the flag was granted to for testing — lost Ask Volley and got an empty space.
 *
 * Nothing renders while the answer is still loading, rather than showing Ask Volley and
 * swapping it out a moment later. That is a brief gap for the cohort only: everyone else
 * settles as soon as the feature list resolves, which is what Ask Volley waits for anyway.
 */
export default function HomeTopSlot(): React.ReactNode {
    const clubInClub = useHomeClubInClub();
    if (clubInClub.loading) return null;
    return clubInClubWidgetRenders(clubInClub) ? (
        <ClubInClubWidget />
    ) : (
        <HomeCallout />
    );
}
